<template>
  <div class="coffee-container">
    <h2 class="title">☕ Gestion du stock de café</h2>
    <p class="subtitle">Gère facilement ton stock de café et son prix</p>

    <!-- Formulaire d'ajout -->
    <form @submit.prevent="ajouterCafe" class="form-card">
      <input
        v-model="item.nom"
        placeholder="Nom du café"
        class="form-control"
      />
      <input
        v-model.number="item.quantite"
        type="number"
        placeholder="Quantité (kg)"
        class="form-control"
      />
      <input
        v-model.number="item.prixU"
        type="number"
        placeholder="Prix unitaire (MAD)"
        class="form-control"
      />
      <input
        v-model="item.date"
        type="date"
        class="form-control"
      />
      <button class="btn-add">Ajouter</button>
    </form>

    <!-- Liste des cafés -->
    <div v-if="cafes.length" class="list-section">
      <h4 class="list-title">Liste des cafés</h4>
      <ul class="coffee-list">
        <li
          v-for="c in cafes"
          :key="c.id"
          class="coffee-item"
        >
          <div>
            <strong>{{ c.nom }}</strong>
            <span class="qty">
              {{ c.quantite }} kg × {{ c.prixU }} MAD = 
              <b>{{ c.totalPrix }} MAD</b>
            </span>
            <span v-if="c.date" class="date">📅 {{ formatDate(c.date) }}</span>
          </div>
          <button class="btn-delete" @click="supprimerCafe(c.id)">✖</button>
        </li>
      </ul>

      <p class="total">
        Total du stock :
        <strong>{{ totalGeneral }} MAD</strong>
      </p>
    </div>

    <div v-else class="empty-state">
      <p>Aucun café enregistré pour le moment.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CoffeeStock",
  data() {
    return {
      item: { nom: "", quantite: null, prixU: null, date: this.today() },
    };
  },
  computed: {
    ...mapGetters("coffee", ["all"]),
    cafes() {
      return this.all;
    },
    totalGeneral() {
      return this.cafes.reduce((s, c) => s + Number(c.totalPrix || 0), 0);
    },
  },
  methods: {
    ...mapActions("coffee", ["add", "fetch", "remove"]),
    today() {
      return new Date().toISOString().split("T")[0];
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString();
    },
    async ajouterCafe() {
      if (!this.item.nom || !this.item.quantite || !this.item.prixU) return;

      const totalPrix = this.item.quantite * this.item.prixU;
      await this.add({ ...this.item, totalPrix });

      this.item = { nom: "", quantite: null, prixU: null, date: this.today() };
    },
    async supprimerCafe(id) {
      await this.remove(id);
    },
  },
  created() {
    this.fetch();
  },
};
</script>

<style scoped>
.coffee-container {
  background: #f8fafc;
  min-height: 100vh;
  padding: 25px 15px 60px;
  font-family: "Poppins", Avenir, Helvetica, sans-serif;
  color: #2b2b2b;
}

.title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 20px;
}

.form-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
}

.btn-add {
  background: linear-gradient(135deg, #1cc88a, #17a673);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}
.btn-add:hover {
  opacity: 0.9;
}

/* Liste */
.list-section {
  margin-top: 25px;
}
.list-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.coffee-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.coffee-item {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.qty {
  color: #555;
  margin-left: 5px;
  font-size: 13px;
}
.date {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: 2px;
}
.btn-delete {
  background: #f87171;
  border: none;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-weight: bold;
  cursor: pointer;
}
.btn-delete:hover {
  background: #ef4444;
}

.total {
  margin-top: 10px;
  font-weight: 600;
  text-align: right;
  color: #1e293b;
}

.empty-state {
  margin-top: 30px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
